// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { EvaluationAiAreaId } from './EvaluationAiAreaId'
import {
  EvaluationAiAreaNavigation,
  EvaluationAiAreaNavigationIcon,
} from './EvaluationAiAreaNavigation'
import { EvaluationAiAreaRoutes } from './EvaluationAiAreaRoutes'

const LazyEvaluationAiComponent = lazy(() => import('./EvaluationAiArea'))

const EvaluationAiComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyEvaluationAiComponent />
  </SuspenseLoadingWrapper>
)

export const EvaluationAiArea = {
  id: EvaluationAiAreaId,
  Icon: EvaluationAiAreaNavigationIcon,
  NavigationComponent: EvaluationAiAreaNavigation,
  route: {
    path: EvaluationAiAreaRoutes.route,
    component: EvaluationAiComponent,
  },
}
